export var AlignPoint;
(function (AlignPoint) {
    AlignPoint["bottom"] = "bottom";
    AlignPoint["center"] = "center";
    AlignPoint["middle"] = "middle";
    AlignPoint["left"] = "left";
    AlignPoint["right"] = "right";
    AlignPoint["top"] = "top";
})(AlignPoint || (AlignPoint = {}));



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/align-point.js
// module id = 213
// module chunks = 93